import styled from 'styled-components';

const PhoneImage = styled.img`
  width: 100%;
  pointer-events: none;
`;

export default PhoneImage;



// WEBPACK FOOTER //
// ./src/kentico-blocks/ImageSlider/ImageSlide/PhoneImage.jsx